
import { Component, Vue } from "vue-property-decorator";
import { IStorageModel } from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";
import {
  createStorage,
  defaultSpaceData,
  deleteStorage,
  getStorages,
  updateStorage,
} from "@/api/storages";
import { Form } from "element-ui";
import {
  getStorageType,
  getStorageTypeName,
  StorageType,
} from "@/commons/StorageType";
import { cloneDeep } from "lodash";

@Component({
  name: "Space",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  private type = null;
  private parentId = null;
  private textMap = {
    update: "编辑",
    create: "新增",
  };
  private tempSpaceData = defaultSpaceData;
  private dialogStatus = "";
  private dialogFormVisible = false;
  private reservoirRegions: IStorageModel[] = [];
  private rules = {
    name: [{ required: true, message: "名称不能为空", trigger: "blur" }],
    isMultiple: [
      {
        required: this.type === "row",
        message: "请选择是否小件库区",
        trigger: "blur",
      },
    ],
  };

  created() {
    this.initData();
  }

  private getHiddenColumns() {
    if (
      this.$route.meta.buttonCodes &&
      Array.isArray(this.$route.meta.buttonCodes)
    ) {
      return this.$route.meta.buttonCodes.includes("actionColumns");
    }
  }

  private async initData() {
    await this.getSpacesList();
  }

  private async getSpacesList() {
    const content: any = await getStorages();
    this.reservoirRegions = content;
  }

  private handleCreate(row: IStorageModel) {
    this.type =
      row.storageType === StorageType.ROW.toLocaleUpperCase()
        ? StorageType.COLUMN
        : StorageType.LAYER;
    this.parentId = row.id;
    this.showCreateForm();
    this.clearForm();
  }

  private handleCreateRow() {
    this.type = StorageType.ROW;
    this.showCreateForm();
    this.clearForm();
  }

  private showCreateForm() {
    this.dialogStatus = "create";
    this.dialogFormVisible = true;
  }

  private handleUpdate(row: IStorageModel) {
    this.type = getStorageType(row.storageType);
    this.parentId = row.id;
    this.showUpdateForm();
    this.clearForm();
  }

  private showUpdateForm() {
    this.dialogStatus = "update";
    this.dialogFormVisible = true;
  }

  private closeCrateForm() {
    this.dialogStatus = "";
    this.dialogFormVisible = false;
    this.type = null;
    this.parentId = null;
    this.clearForm();
  }

  private clearForm() {
    this.tempSpaceData = cloneDeep(defaultSpaceData);
  }

  private showCreateBtn(row: IStorageModel) {
    return row.storageType !== StorageType.LAYER.toLocaleUpperCase();
  }

  private getStorageName() {
    return getStorageTypeName(this.type);
  }

  private createData() {
    (this.$refs.dataForm as Form).validate(async (valid) => {
      if (valid) {
        const spaceData = this.tempSpaceData;
        await createStorage({
          ...spaceData,
          type: this.type,
          parentId: this.parentId,
        });
        this.closeCrateForm();
        this.type = null;
        this.parentId = null;
        this.$notify({
          title: "成功",
          message: "创建成功",
          type: "success",
          duration: 2000,
        });
        await this.getSpacesList();
      }
    });
  }

  private updateData() {
    // alert("这是更新操作");
    (this.$refs.dataForm as Form).validate(async (valid) => {
      if (valid) {
        const spaceData = this.tempSpaceData;
        await updateStorage({
          ...spaceData,
          type: this.type,
          parentId: this.parentId,
        });
        this.closeCrateForm();
        this.type = null;
        this.parentId = null;
        this.$notify({
          title: "成功",
          message: "更新成功",
          type: "success",
          duration: 2000,
        });
        await this.getSpacesList();
      }
    });
  }

  private async deleteItem(row: IStorageModel) {
    await deleteStorage(row.id, row.storageType.toLocaleLowerCase()).then(() =>
      this.getSpacesList()
    );
    this.$notify({
      title: "Success",
      message: "Delete Successfully",
      type: "success",
      duration: 2000,
    });
  }

  private getExtraText(row: any) {
    return row.storageType === StorageType.ROW.toLocaleUpperCase()
      ? getStorageTypeName(StorageType.COLUMN)
      : row.storageType === StorageType.COLUMN.toLocaleUpperCase()
      ? getStorageTypeName(StorageType.LAYER)
      : "";
  }

  private getStorageText(row: any) {
    return row.storageType === StorageType.ROW.toLocaleUpperCase()
      ? getStorageTypeName(StorageType.ROW)
      : row.storageType === StorageType.COLUMN.toLocaleUpperCase()
      ? getStorageTypeName(StorageType.COLUMN)
      : getStorageTypeName(StorageType.LAYER);
  }

  private formatIsMultiple(row: IStorageModel) {
    return row.storageType === StorageType.ROW.toLocaleUpperCase()
      ? row.storageRowType === "MULTIPLE"
        ? "小件库区"
        : "整件库区"
      : "-";
  }
}
